import {PUSH_LID_TO_TARGET} from "../constants/constants";

export const pushLidToTarget = (step, lid, top, left) => {
    return {
        type : PUSH_LID_TO_TARGET,
        payload : {
            step : step,
            lid : lid,
            top: top,
            left : left
        }
    };
};


// WEBPACK FOOTER //
// ./src/actions/pushLidToTarget.js